import type { BaseEntity } from '.';
import ODataEntity from './odata/decorator';

@ODataEntity('', 'KhungNoiDungsUpload')
export default class KhungNoiDungUpload implements BaseEntity<string> {
  id?: string;
  name?: string;
  code?: string;
}
export interface KhungNoiDungUploadResponse {
  value?: KhungNoiDungUpload[];
  count?: number;
}
